module.exports = __webpack_public_path__ + "img/iron-heart.e73cf058.png";